import { configureStore as configureStoreReduxToolkit } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';

import { rootReducer } from '../../reducers';

const reducer = rootReducer();

export const configureStore = () =>
    configureStoreReduxToolkit({
        reducer,
        middleware: getDefaultMiddleware => getDefaultMiddleware({ immutableCheck: false, serializableCheck: false }),
    });

export const store = configureStore();
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
